import React from 'react';
import { IoMdClose } from "react-icons/io";
import successIcon from '../assets/success.svg';

const SuccessModal = ({ setShowModal, resetFields, page }) => {
  // Define messages based on the page type
  const message = page === "rate" 
    ? "Your rating has been submitted successfully!" 
    : page === "edit" 
      ? "Your edits have been saved successfully!" 
      : "Success!";

  return (
    <div>
      <div
        onClick={() => {
          if (page === "edit") {
            window.location.href = "/"; // Redirect to home page for edit
          } else {
            setShowModal(false); // Close modal for rate
          }
        }}
        className="cursor-pointer h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-[110] outline-none focus:outline-none scrollbar-hide"
      >
        <div id='modal' className="relative my-6 mx-[2%] sm:mx-0">
          {/*content*/}
          <div className="cursor-default fixed relative rounded-[20px] border-0 shadow-lg flex flex-col w-full bg-white outline-none focus:outline-none">
            <div className='w-[327px] md:w-[500px] pt-[27px] pb-[56px] px-[42px] md:px-[53px] flex flex-col gap-[30px]'>
              <div className='w-full flex items-end justify-end'>
                <IoMdClose 
                  onClick={() => {
                    if (page === "edit") {
                      window.location.href = "/"; // Close and redirect home for edit
                    } else {
                      setShowModal(false); // Just close for rate
                    }
                  }} 
                  className='cursor-pointer w-[25px] h-[25px]' 
                />
              </div>
              <div className='w-full flex flex-col gap-[13px] items-center justify-center'>
                <div className='mt-[6px] flex bg-[#4FBF26D9] p-[2.5] rounded-full items-center justify-center w-[35px] h-[35px]'>
                  <img src={successIcon} alt="Success Icon" className='' />
                </div>
                <div className='w-full flex flex-col gap-[3px] items-center justify-center text-center'>
                  <h2 className='font-black text-[16px] leading-[21.6px] md:text-[24px] md:leading-[32.4px]'>Success!</h2>
                  <p className='font-medium text-[14px] text-ravash leading-[18.9px]'>{message}</p>
                </div>
                <div className='mt-[12px] flex flex-col md:flex-row gap-[13px] items-center justify-center w-[200px] md:w-full'>
                  {page === "rate" ? (
                    <>
                      <button
                        onClick={() => {
                          resetFields();
                          setShowModal(false); // Close modal
                        }}
                        className='w-full h-[50px] rounded-[80px] bg-ravblue flex items-center text-center justify-center font-bold text-[16px] text-white leading-[21.6px]'
                      >
                        Rate Another Vendor
                      </button>
                      <button
                        onClick={() => {
                          setShowModal(false);
                          window.location.href = "/"; // Redirect to home page
                        }}
                        className='w-full h-[50px] rounded-[80px] bg-white border-solid border-[1px] border-ravash flex items-center text-center justify-center font-bold text-[16px] text-[#707070] leading-[21.6px]'
                      >
                        Go back home
                      </button>
                    </>
                  ) : page === "edit" ? (
                    <>
                      <button
                        onClick={() => {
                          setShowModal(false);
                          window.location.href = "/profile"; // Redirect to profile page
                        }}
                        className='w-full h-[50px] rounded-[80px] bg-ravblue flex items-center text-center justify-center font-bold text-[16px] text-white leading-[21.6px]'
                      >
                        Go to Profile Page
                      </button>
                      <button
                        onClick={() => {
                          setShowModal(false);
                          window.location.href = "/"; // Redirect to home page
                        }}
                        className='w-full h-[50px] rounded-[80px] bg-white border-solid border-[1px] border-ravash flex items-center text-center justify-center font-bold text-[16px] text-[#707070] leading-[21.6px]'
                      >
                        Go to Home
                      </button>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-[100] bg-black opacity-50 overflow-hidden"></div>
    </div>
  );
};

export default SuccessModal;
